import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ScheduleForm from "./ScheduleForm";
import "./LeadFormModal.scss";

const LeadFormModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [location.pathname]);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <ScheduleForm showCloseIcon handleClose={handleClose} />
      </div>
    </div>
  );
};

export default LeadFormModal;
